import { render, staticRenderFns } from "./StartFinishButtons.vue?vue&type=template&id=215bf100&"
import script from "./StartFinishButtons.vue?vue&type=script&lang=js&"
export * from "./StartFinishButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports